export default __webpack_public_path__ + "static/media/image_323.eee39b72.png";